/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetDeliveryAreas200ResponseInnerGeometry } from './GetDeliveryAreas200ResponseInnerGeometry';
import {
    GetDeliveryAreas200ResponseInnerGeometryFromJSON,
    GetDeliveryAreas200ResponseInnerGeometryFromJSONTyped,
    GetDeliveryAreas200ResponseInnerGeometryToJSON,
    GetDeliveryAreas200ResponseInnerGeometryToJSONTyped,
} from './GetDeliveryAreas200ResponseInnerGeometry';
import type { GetDeliveryAreas200ResponseInnerType } from './GetDeliveryAreas200ResponseInnerType';
import {
    GetDeliveryAreas200ResponseInnerTypeFromJSON,
    GetDeliveryAreas200ResponseInnerTypeFromJSONTyped,
    GetDeliveryAreas200ResponseInnerTypeToJSON,
    GetDeliveryAreas200ResponseInnerTypeToJSONTyped,
} from './GetDeliveryAreas200ResponseInnerType';

/**
 * 
 * @export
 * @interface GetDeliveryAreas200ResponseInner
 */
export interface GetDeliveryAreas200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof GetDeliveryAreas200ResponseInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetDeliveryAreas200ResponseInner
     */
    locationId: string;
    /**
     * 
     * @type {string}
     * @memberof GetDeliveryAreas200ResponseInner
     */
    name?: string;
    /**
     * 
     * @type {GetDeliveryAreas200ResponseInnerType}
     * @memberof GetDeliveryAreas200ResponseInner
     */
    type: GetDeliveryAreas200ResponseInnerType;
    /**
     * 
     * @type {GetDeliveryAreas200ResponseInnerGeometry}
     * @memberof GetDeliveryAreas200ResponseInner
     */
    geometry: GetDeliveryAreas200ResponseInnerGeometry;
    /**
     * 
     * @type {number}
     * @memberof GetDeliveryAreas200ResponseInner
     */
    deliveryFee?: number;
    /**
     * 
     * @type {number}
     * @memberof GetDeliveryAreas200ResponseInner
     */
    deliveryExtraMinutes?: number;
    /**
     * 
     * @type {number}
     * @memberof GetDeliveryAreas200ResponseInner
     */
    minimumBasket?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetDeliveryAreas200ResponseInner
     */
    enabled: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetDeliveryAreas200ResponseInner
     */
    position: number;
    /**
     * 
     * @type {string}
     * @memberof GetDeliveryAreas200ResponseInner
     */
    color: string;
}

/**
 * Check if a given object implements the GetDeliveryAreas200ResponseInner interface.
 */
export function instanceOfGetDeliveryAreas200ResponseInner(value: object): value is GetDeliveryAreas200ResponseInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('locationId' in value) || value['locationId'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('geometry' in value) || value['geometry'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    if (!('position' in value) || value['position'] === undefined) return false;
    if (!('color' in value) || value['color'] === undefined) return false;
    return true;
}

export function GetDeliveryAreas200ResponseInnerFromJSON(json: any): GetDeliveryAreas200ResponseInner {
    return GetDeliveryAreas200ResponseInnerFromJSONTyped(json, false);
}

export function GetDeliveryAreas200ResponseInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDeliveryAreas200ResponseInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'locationId': json['locationId'],
        'name': json['name'] == null ? undefined : json['name'],
        'type': GetDeliveryAreas200ResponseInnerTypeFromJSON(json['type']),
        'geometry': GetDeliveryAreas200ResponseInnerGeometryFromJSON(json['geometry']),
        'deliveryFee': json['deliveryFee'] == null ? undefined : json['deliveryFee'],
        'deliveryExtraMinutes': json['deliveryExtraMinutes'] == null ? undefined : json['deliveryExtraMinutes'],
        'minimumBasket': json['minimumBasket'] == null ? undefined : json['minimumBasket'],
        'enabled': json['enabled'],
        'position': json['position'],
        'color': json['color'],
    };
}

export function GetDeliveryAreas200ResponseInnerToJSON(json: any): GetDeliveryAreas200ResponseInner {
    return GetDeliveryAreas200ResponseInnerToJSONTyped(json, false);
}

export function GetDeliveryAreas200ResponseInnerToJSONTyped(value?: GetDeliveryAreas200ResponseInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'locationId': value['locationId'],
        'name': value['name'],
        'type': GetDeliveryAreas200ResponseInnerTypeToJSON(value['type']),
        'geometry': GetDeliveryAreas200ResponseInnerGeometryToJSON(value['geometry']),
        'deliveryFee': value['deliveryFee'],
        'deliveryExtraMinutes': value['deliveryExtraMinutes'],
        'minimumBasket': value['minimumBasket'],
        'enabled': value['enabled'],
        'position': value['position'],
        'color': value['color'],
    };
}

